const icon = require("./images/location64x64.png");
const locationSvg = require("!!raw-loader!./images/location.svg").default;
const l14 = require("./images/ligne14.png");
const l15 = require("./images/ligne15.png");
const l16 = require("./images/ligne16.png");
const l17 = require("./images/ligne17.png");
const l18 = require("./images/ligne18.png");
const eole = require("./images/eole.png");

const api_keys = require('../api_keys.json.erb')
const transport_style = require('./styles/transports.json')
const defaults_style = require('./styles/default.json')
const schools_style = require('./styles/schools.json')
const stops_list = require('./GPE_GARE_LOCALISATION.json')
const sub_lines = require('./GPE_LIGNE_TRACE.json')

const controllerDurationHtml = require("./controller.html")

require("./map.scss")


class MapBuilder {

  constructor(mapTarget, latitude, longitude, searchInput, primaryColor) {
    this.latLng = { lat: latitude, lng: longitude};
    this.mapTarget = mapTarget;
    this.searchInput = searchInput;
    this.searchFromSideBar = false;
    this.primaryColor = primaryColor;
  }


  setup() {
    if(this.mapTarget) {
      var script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${api_keys.google_api_key}&callback=initMap&libraries=geometry,places`;
      script.defer = true;
      document.head.appendChild(script);

      window.initMap = () => {
        var map_options_default = {
          zoom: 17,
          center: this.latLng,
          disableDefaultUI: true,
          zoomControl: true,
          mapTypeControlOptions: {
            mapTypeIds: ["global", "transports", "schools", "satellite", "bicycle"],
          }
        }

        const options = {
          componentRestrictions: { country: "fr" },
          fields: ["formatted_address", "geometry", "name"],
          strictBounds: false
        };

        const input = document.getElementById('text-adress');
        const autocomplete = new google.maps.places.Autocomplete(input, options);

        const customSvg = locationSvg.replace(/rgb\(0, 0, 0\);/, this.primaryColor);

        this.googleMap = new google.maps.Map(this.mapTarget.get(0), map_options_default);
        new google.maps.Marker({
          map: this.googleMap,
          position: this.latLng,
          icon: {
            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(customSvg),
            optimized: true
          },
          disableDefaultUI: true,
          clickable: false
        });

        var map = this.googleMap;
        const marker = new google.maps.Marker({
          map,
          anchorPoint: new google.maps.Point(0, -29),
        });

        autocomplete.bindTo("bounds", this.googleMap);
        this.placeService = new google.maps.places.PlacesService(map);


        this.directionsService = new google.maps.DirectionsService();

        this.directionsRenderer =  new google.maps.DirectionsRenderer({
          map: this.googleMap,
          suppressMarkers: true,
          preserveViewport: true
        });

        this.createStyles();
        this.assignStyles();
        this.setupInfoWindowListener();

        $("#schools").on('click', () => {
          this.selectMapControl($("#schools"));

          this.googleMap.setMapTypeId('schools');
          //Click to close info window
          $('.gm-ui-hover-effect').trigger('click');
          this.directionsRenderer.setMap(null);
        });

        $("#normal").on('click', () => {
          this.selectMapControl($("#normal"));

          this.googleMap.setMapTypeId('global');
          $('.gm-ui-hover-effect').trigger('click');
          this.directionsRenderer.setMap(null);
        });

        $("#transports").on('click', () => {
          this.selectMapControl($("#transports"));

          this.googleMap.setMapTypeId('transports');

          $('.gm-ui-hover-effect').trigger('click');
          this.directionsRenderer.setMap(null);
        });


        $("#grdparis").on('click', () => {
          this.selectMapControl($("#grdparis"));

          this.googleMap.setMapTypeId('transports');
          this.createNewLineStops()


          $('.gm-ui-hover-effect').trigger('click');
          this.directionsRenderer.setMap(null);
        });

        $("#bicycle").on('click', () => {
          this.selectMapControl($("#bicycle"));

          this.googleMap.setMapTypeId('transports');

          this.bikeLayer = new google.maps.BicyclingLayer();
          this.bikeLayer.setMap(map);

          $('.gm-ui-hover-effect').trigger('click');
          this.directionsRenderer.setMap(null);
        });

        $("#satellite").on('click', () => {
          this.selectMapControl($("#satellite"));

          this.googleMap.setMapTypeId('satellite');
          $('.gm-ui-hover-effect').trigger('click');
          this.directionsRenderer.setMap(null);
        });

        this.googleMap.setMapTypeId('global');

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();

          if (!place.geometry || !place.geometry.location) {
            return;
          }

          // If the place has a geometry, then present it on a map.
          if (place.geometry.viewport) {
            this.googleMap.fitBounds(place.geometry.viewport);
          } else {
            this.googleMap.setCenter(place.geometry.location);
            this.googleMap.setZoom(17);
          }
          marker.setPosition(place.geometry.location);
          marker.setVisible(true);
          this.currentTargetLatLng = place.geometry.location;
          this.calculateAndDisplayRoute("BICYCLING", true, false);
          this.calculateAndDisplayRoute("TRANSIT", true, true);
          this.calculateAndDisplayRoute("WALKING", true, false);
          this.calculateAndDisplayRoute("DRIVING", true, false);

          $('.gm-ui-hover-effect').trigger('click');
          this.addListenersOnTravelTimePanel();

        });

        this.googleMap.addListener('click', (e) => {
          if(e.placeId) {
            if(marker) {
              marker.setMap(null);
            }
            if(this.directionsRenderer)
              this.directionsRenderer.setMap(null);

            var request = {
              placeId: e.placeId,
              fields: ['name', 'formatted_address' ]
            };

            this.currentTargetLatLng = e.latLng;

            this.placeService.getDetails(request, (e) => {
              //TODO sandbox
              $('#text-adress').val(e.formatted_address);
              this.calculateAndDisplayRoute("BICYCLING", true, false);
              this.calculateAndDisplayRoute("TRANSIT", true, true);
              this.calculateAndDisplayRoute("WALKING", true, false);
              this.calculateAndDisplayRoute("DRIVING", true, false);
            });

            if(this.infoWindowDefault) { //CHECK IF INFO WINDOW IS ALREADY CREATED
              var divToFill = this.infoWindowDefault.parentNode

              if (divToFill.querySelector("#time_id")) {
                divToFill.removeChild(divToFill.querySelector("#time_id"))
              }
            }
            this.addListenersOnTravelTimePanel();
          }
        });
      };
    }
  }

  createNewLineStops() {
    this.markers = [];
    this.linePaths = [];
    stops_list.forEach((stop) => {
      this.googleMapForMarker = this.googleMap;
      const marker = new google.maps.Marker({
        map: this.googleMap,
        position: { lat: stop.LAT, lng: stop.LONG },
        title: stop.LIBELLE,
        disableDefaultUI: false,
        icon: this.getIconForLine(stop.LIGNE),
        optimized: true,
      });

      marker.addListener("click", (e) => {

        this.currentTargetLatLng = e.latLng;
        $('#text-adress').val(stop.LIBELLE + " - " + stop.LIGNE);

        this.calculateAndDisplayRoute("BICYCLING", true, false);
        this.calculateAndDisplayRoute("TRANSIT", true, false);
        this.calculateAndDisplayRoute("WALKING", true, true);
        this.calculateAndDisplayRoute("DRIVING", true, false);
      });
      this.markers.push(marker)
    });

    sub_lines.forEach((line) => {
      const linePath = new google.maps.Polyline({
        path: line.points,
        geodesic: true,
        strokeColor: line.color,
        strokeOpacity: 1.0,
        strokeWeight: 6,
      });

      linePath.setMap(this.googleMap);
      this.linePaths.push(linePath);
    });


   this.lines_listener =  this.googleMap.addListener('zoom_changed', () => {
      console.log(this.googleMap.getZoom());
      if (this.googleMap.getZoom() < 10) {
        console.log("remove markers");
        if(this.markers != null) {
          this.markers.forEach((marker) => {
            marker.setMap(null);
          });
        }
        if (this.linePaths != null) {
          this.linePaths.forEach((line) => {
            line.setMap(null);
          });
        }
      } else {
        if(this.markers != null) {
          this.markers.forEach((marker) => {
            marker.setMap(this.googleMap);
          });
        }
        if (this.linePaths != null) {
          this.linePaths.forEach((line) => {
            line.setMap(this.googleMap);
          });
        }
      }
    });
  }

  getIconForLine(line) {
    switch (line){
      case "L14":
        return {
          url: l14,
          scaledSize: new google.maps.Size(22, 22), // scaled size
          origin: new google.maps.Point(0,0), // origin
          anchor: new google.maps.Point(10, 10) // anchor
        };
      case "L15":
      case "L15/L14":
      case "L14/L15/L16/L17":
      case "L15/L16":
        return {
          url: l15,
          scaledSize: new google.maps.Size(22, 22), // scaled size
          origin: new google.maps.Point(0,0), // origin
          anchor: new google.maps.Point(10, 10) // anchor
        };
      case "L16":
      case "L16/L17":
        return {
          url: l16,
          scaledSize: new google.maps.Size(22, 22), // scaled size
          origin: new google.maps.Point(0,0), // origin
          anchor: new google.maps.Point(10, 10) // anchor
        };

      case "L17":
        return {
          url: l17,
          scaledSize: new google.maps.Size(22, 22), // scaled size
          origin: new google.maps.Point(0,0), // origin
          anchor: new google.maps.Point(10, 10) // anchor
        };
      case "L14/L18":
      case "L18":
        return {
          url: l18,
          scaledSize: new google.maps.Size(22, 22), // scaled size
          origin: new google.maps.Point(0,0), // origin
          anchor: new google.maps.Point(10, 10) // anchor
        };
      case "RER EOLE":
        return {
          url: eole,
          scaledSize: new google.maps.Size(22, 22), // scaled size
          origin: new google.maps.Point(0,0), // origin
          anchor: new google.maps.Point(10, 10) // anchor
        };
      default:
        console.log(line);
      }
  }

  selectMapControl(target) {
    $("#normal").removeClass('active');
    $("#schools").removeClass('active');
    $("#transports").removeClass('active');
    $("#satellite").removeClass('active');
    $("#bicycle").removeClass('active');
    $("#grdparis").removeClass('active');
    this.removeActiveOnButtonsOnTravelTimePanel();

    $(target).addClass('active');

    if (this.bikeLayer != null) {
      this.bikeLayer.setMap(null);
    }

    if(this.kmlLayer != null) {
      this.kmlLayer.setMap(null);
    }
    if(this.markers != null) {
      this.markers.forEach((marker) => {
        marker.setMap(null);
      });
    }
    if (this.linePaths != null) {
      this.linePaths.forEach((line) => {
        line.setMap(null);
      });
    }

    if (this.lines_listener != null) {
      google.maps.event.removeListener(this.lines_listener);
    }

  }

  setupInfoWindowListener() {
      //CREATE LISTENER TO RETRIEVE DEFAULT INFO WINDOW TO MODIFY IT AFTERWARDS
      // (because we do not want to loose the default information such as bus number etc...)
      var me = this
      MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
      var observer = new MutationObserver(function(mutations, observer) {
        mutations.forEach(function(mutation) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
              if(mutation.target.firstChild.className == "gm-style-iw gm-style-iw-c") {
                //Remove the link to google map that is really ugly
                var link = mutation.target.getElementsByTagName("A")[0];
                if (link) {
                  var parentLink = link.parentNode;
                  parentLink.removeChild(link)

                }

                var divToFill = mutation.target.getElementsByClassName("gm-style-iw-d")[0]

                var existingControllerWrapper = document.getElementById('controllerDivWrapper');
                if (existingControllerWrapper == null)
                {
                  var controllerDiv = document.createElement("div")
                  controllerDiv.id = 'controllerDivWrapper';
                  controllerDiv.innerHTML = controllerDurationHtml;
                  divToFill.appendChild(controllerDiv);
                  me.infoWindowDefault = controllerDiv;
                  me.createListeners();
                  $('.gm-ui-hover-effect').on('click', () => {
                    me.directionsRenderer.setMap(null);
                  });
                }
              }
          }
      });
    });

    observer.observe(document.getElementById('map'), { subtree: true, childList: true });
  }

  createStyles() {
    this.transportsMapStyle = new google.maps.StyledMapType(
      transport_style,
      { name: "Transports" }
    );

    this.schoolsMapStyle = new google.maps.StyledMapType(
      schools_style,
      { name: "Education" }
    );

    this.mapMapStyle = new google.maps.StyledMapType(
      defaults_style,
      { name: "Global" }
    );
  }

  assignStyles() {
    this.googleMap.mapTypes.set("transports", this.transportsMapStyle);
    this.googleMap.mapTypes.set("schools", this.schoolsMapStyle);
    this.googleMap.mapTypes.set("global", this.mapMapStyle);
  }

 calculateAndDisplayRoute(mode, searchFromSideBar, renderToMap) {
   this.removeActiveOnButtonsOnTravelTimePanel();
    this.directionsService.route(
      {
        origin:  this.latLng,
        destination: this.currentTargetLatLng,
        travelMode: google.maps.TravelMode[mode],
      },
      (response, status) => {
        if (status == "OK") {
          if (renderToMap === true) {
            this.directionsRenderer.setMap(this.googleMap);
            this.directionsRenderer.setDirections(response);

            if(mode === "DRIVING") {
              $("#search_car_time_focus").addClass("active");
              $("#car_button").parent().addClass('active');
            }
            if(mode === "TRANSIT") {
              $("#search_bus_time_focus").addClass("active");
              $("#bus_button").parent().addClass('active');
            }
            if(mode === "WALKING") {
              $("#search_walking_time_focus").addClass("active");
              $("#walking_button").parent().addClass('active');
            }
            if(mode === "BICYCLING") {
              $("#search_bicycle_time_focus").addClass("active");
              $("#bicycle_button").parent().addClass('active');
            }
          }
          if(searchFromSideBar === false) {
            var divToFill = this.infoWindowDefault.parentNode
            if (!divToFill.querySelector("#time_id")) {
              var timeDiv = document.createElement("div")
              timeDiv.id = "time_id"
              timeDiv.innerHTML = response.routes[0].legs[0].duration.text;
              divToFill.appendChild(timeDiv)
            } else {
              var timeDiv = divToFill.querySelector("#time_id");
              timeDiv.innerHTML = response.routes[0].legs[0].duration.text;
            }
          } else {
            if(mode === "DRIVING") {
              $("#search_car_time").html(response.routes[0].legs[0].duration.text);
            }
            if(mode === "TRANSIT") {
              $("#search_bus_time").html(response.routes[0].legs[0].duration.text);
            }
            if(mode === "WALKING") {
              $("#search_walking_time").html(response.routes[0].legs[0].duration.text);
            }
            if(mode === "BICYCLING") {
              $("#search_bicycle_time").html(response.routes[0].legs[0].duration.text);
            }

            this.googleMap.fitBounds(response.routes[0].bounds);
          }
        } else {
          console.log("Directions request failed due to " + status);
        }

      }
    );
  }

  createListeners() {
    $("input#bus_button").on('click', () =>  {
      this.calculateAndDisplayRoute("TRANSIT", false, true);
    });

    $("input#car_button").on('click', () => {
      this.calculateAndDisplayRoute("DRIVING", false, true);
    });

    $("input#bicycle_button").on('click', () => {
      this.calculateAndDisplayRoute("BICYCLING", false, true);
    });

    $("input#walking_button").on('click', () => {
      this.calculateAndDisplayRoute("WALKING", false, true);
    });
  }

  addListenersOnTravelTimePanel() {
    this.removeActiveOnButtonsOnTravelTimePanel();

    $("#search_walking_time_focus").show();
    $("#search_walking_time_focus").off('click').on('click', () => {
      this.directionsRenderer.setMap(null);
      this.calculateAndDisplayRoute("WALKING", true, true);
    });
    $("#search_bus_time_focus").show();
    $("#search_bus_time_focus").off('click').on('click', () => {
      this.directionsRenderer.setMap(null);
      this.calculateAndDisplayRoute("TRANSIT", true, true);
    });

    $("#search_car_time_focus").show();
    $("#search_car_time_focus").off('click').on('click', () => {
      this.directionsRenderer.setMap(null);
      this.calculateAndDisplayRoute("DRIVING", true, true);
    });

    $("#search_bicycle_time_focus").show();
    $("#search_bicycle_time_focus").off('click').on('click', () => {
      this.directionsRenderer.setMap(null);
      this.calculateAndDisplayRoute("BICYCLING", true, true);
    });
  }

  removeActiveOnButtonsOnTravelTimePanel() {
    $("#search_walking_time_focus").removeClass("active");
    $("#search_bus_time_focus").removeClass("active");
    $("#search_car_time_focus").removeClass("active");
    $("#search_bicycle_time_focus").removeClass("active");

    $("#car_button").parent().removeClass("active");
    $("#walking_button").parent().removeClass("active");
    $("#bus_button").parent().removeClass("active");
    $("#bicycle_button").parent().removeClass("active");
  }
};

var buildMap = function(latitude, longitude, searchInput, primaryColor) {
  var builder = new MapBuilder($(this), latitude, longitude, searchInput, primaryColor);
  builder.setup();

  return builder;
};

export default buildMap;
